import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ResetPasswordEmail } from '@shared/interfaces/auth/reset-password-email.interface';
import { ResetPassword } from '@shared/interfaces/auth/reset-password.interface';
import { TokenParams } from '@shared/interfaces/auth/token-params.interface';
import { CustomLogin } from '@shared/interfaces/custom-login.interface';
import { Error } from '@shared/interfaces/error.interface';
import { Response } from '@shared/models/response.model';
import { User } from '@shared/models/user/user.model';
import { MenuService } from '@shared/services/menu.service';
import { BaseAuthComponent } from '../../../../layouts/guest/pages/home/components/base-auth.component';
import { AuthComponent } from '../../auth.component';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
})
export class ResetPassComponent
  extends BaseAuthComponent
  implements OnInit, OnDestroy, CustomLogin
{
  resetPasswordToken: string = null;
  resetPasswordName: string = null;
  email: string = '';
  formPassConfirm: UntypedFormGroup = new UntypedFormGroup({}); // custom form for reset-pass-confirm
  authFromHelpUkraine: boolean = false;
  authWcd: boolean = false;
  constructor(public authComponent: AuthComponent, public navigationService: MenuService) {
    super();
    this.layoutTitle = this.translate.instant('AUTH.password_reset_title');
  }

  ngOnInit() {
    // get token from params url. If (!null) show box resetPassConfirm
    const subActiveRouteParams = this.activatedRoute.queryParams.subscribe(
      (params: TokenParams) => {
        this.resetPasswordToken = params.token;
        this.resetPasswordName = params.name;
        !!this.email && setTimeout(() => this.form.setValue({ ['email']: params.email }));
      }
    );
    this.someSubscriptions.add(subActiveRouteParams);

    // update layout title (left side)
    this.authComponent.titlePageEmitter.emit(this.layoutTitle);
    this.authFromHelpUkraine = this.navigationService.isUkraineUrl();
    this.authWcd = this.navigationService.isWcd();
  }

  get btnDisabledConfirm() {
    return this.loading || this.formPassConfirm.invalid;
  }

  resetPass() {
    if (!this.form.invalid) {
      this.loading = true;
      const pack: ResetPasswordEmail = { email: this.form.value.email };
      const subResetPass = this.authService.resetPassData(pack).subscribe((res: Response<User>) => {
        this.toast.success(
          this.translate.instant('AUTH.check_your_email') + pack.email,
          this.translate.instant('AUTH.reset_password_success')
        );
        this.router.navigate([], { queryParams: this.authPage('login') });
        setTimeout(() => {
          this.loading = false;
        }, 1200);
      }, this.onResetPassError.bind(this));
      this.someSubscriptions.add(subResetPass);
    } else {
      this.toast.error(
        this.translate.instant('AUTH.invalid_email'),
        this.translate.instant('AUTH.reset_password_error')
      );
    }
  }

  onResetPassError(error: Error) {
    setTimeout(() => {
      this.loading = false;
    }, 1200);
    if (error?.message === 'cannot_reset_social_media_user') {
      this.toast.error(
        this.translate.instant('AUTH.cannot_reset_social_media_user'),
        this.translate.instant('AUTH.reset_password_error')
      );
    } else {
      this.toast.error(
        this.translate.instant('AUTH.unexpected_error'),
        this.translate.instant('AUTH.reset_password_error')
      );
    }
  }

  resetPassConfirm() {
    if (!this.formPassConfirm.invalid) {
      const route = this.storage.user ? 'resetPassConfirmData' : 'resetPassFormConfirmData';
      this.loading = true;
      const pack: ResetPassword = {
        password: this.formPassConfirm.value.password,
        token: this.resetPasswordToken,
      };
      const subResetPassConfirm = this.authService[route](pack).subscribe((res: Response<User>) => {
        this.toast.success(
          this.translate.instant('AUTH.password_was_changed'),
          this.translate.instant('AUTH.reset_password_confirm_success')
        );
        this.router.navigate([], { queryParams: this.authPage('login') });
        setTimeout(() => {
          this.loading = false;
        }, 1200);
      }, this.onResetPassConfirmError.bind(this));
      this.someSubscriptions.add(subResetPassConfirm);
    }
  }

  onResetPassConfirmError(error: Error) {
    setTimeout(() => {
      this.loading = false;
    }, 1200);
    if (error?.message === 'wrong_token_passed') {
      this.toast.error(
        this.translate.instant('AUTH.password_was_not_changed'),
        this.translate.instant('AUTH.reset_password_wrong_token')
      );
    } else {
      this.toast.error(
        this.translate.instant('AUTH.password_was_not_changed'),
        this.translate.instant('AUTH.reset_password_confirm_error')
      );
    }
  }
}
